import { createSlice, current, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../../app/store';
import { channelsHandler, handleChannelRemove, handleGroupDevicesFilter, handleReallocateChannels } from './helpers';

const loadGroupTrendsInitialState: any = {
    type: 'area',
    secondary: [],
    viewAllButton: false,
    maxCount: 6,
    isAutomated: true,
    isTotalCountVisible: false,
    countMode: 'custom',
    duration: 24,
    channelData: [],
    trendsLegendData: {},
};

const loadGroupTrendsWidgetSlice = createSlice({
    name: 'load_group_trends',
    initialState: loadGroupTrendsInitialState,
    reducers: {
        resetLoadGroupTrendsConfiguration: () => {
            return loadGroupTrendsInitialState;
        },
        setPredefinedLoadGroupTrends: (state: RootState, action: PayloadAction<any>) => {
            Object.keys(action.payload)?.forEach((key: string) => {
                if (key === 'selectedNodes') {
                    state[key] = action.payload[key];
                } else if (key === 'secondary') {
                    if (typeof action.payload[key][0] === 'string') {
                        state[key] = action.payload[key]?.map((item: any) => ({ id: item }));
                    } else {
                        state[key] = action.payload[key];
                    }
                } else state[key] = action.payload[key];
            });
        },
        setLoadGroupTrends: (state: RootState, action: PayloadAction<any>) => {
            channelsHandler(state, action, 'id');
        },
        setLoadGroupTrendsData: (state: RootState, action: PayloadAction<any>) => {
            state['secondary'] = action.payload;
        },
        setLoadGroupTrendsFilters: (state: RootState, action: PayloadAction<any>) => {
            state['filters'] = action.payload;
        },
        reAllocateLoadGroupTrends: (state: RootState, action: PayloadAction<any>) => {
            handleReallocateChannels(state, action);
        },
        removeLoadGroupTrends: (state: RootState, action: PayloadAction<any>) => {
            handleChannelRemove(state, action, 'id');
        },
        setLoadGroupTrendsNodes: (state: RootState, action: PayloadAction<any>) => {
            handleGroupDevicesFilter(state, action);
        },
        setLoadGroupTrendsPreferences: (state: RootState, action: PayloadAction<any>) => {
            if (action.payload.key === 'isAutomated') {
                state['secondary'] = [];
            }
            state[action.payload.key] = action.payload.value;
        },
        setLoadGroupTrendsLegendData: (state: any, action: PayloadAction<any>) => {
            const currentState = current(state);
            state.trendsLegendData[action.payload.id] = action.payload.value;
            state.trendsLegendData[action.payload.id] = {
                ...currentState?.trendsLegendData?.[action.payload.id],
                ...action?.payload?.value,
            };
        },
        setLoadGroupTrendsLegendChannel: (state: any, action: PayloadAction<any>) => {
            const currentState = current(state);
            state.trendsLegendData[action.payload.id] = {
                ...currentState?.trendsLegendData?.[action.payload.id],
                channelId: action?.payload?.channelId,
            };
        },
        setLoadGroupTrendsUnitAndDuration: (state: any, action: PayloadAction<any>) => {
            const currentState = current(state);
            state.trendsLegendData[action.payload.id] = {
                ...currentState?.trendsLegendData?.[action.payload.id],
                [action.payload.key]: action.payload.value,
            };
        },
        resetLoadGroupTrendsLegendData: (state: any) => {
            state.trendsLegendData = {};
        },
    },
    extraReducers: (builder) => {
        builder.addCase('widgetConfiguration/toggleDeviceLinkMode', (state) => {
            state.secondary = [];
            state.selectedNodes = [];
        });
        builder.addCase('widgetConfiguration/setWidgetDevice', (state, action: any) => {
            if (action.payload.reset) {
                state.secondary = [];
            }
        });
        builder.addCase('widgetConfiguration/setWidgetSource', (state) => {
            state.secondary = [];
        });
    },
});

export const {
    resetLoadGroupTrendsConfiguration,
    setLoadGroupTrendsFilters,
    setLoadGroupTrendsNodes,
    reAllocateLoadGroupTrends,
    setPredefinedLoadGroupTrends,
    removeLoadGroupTrends,
    setLoadGroupTrends,
    setLoadGroupTrendsData,
    setLoadGroupTrendsPreferences,
    setLoadGroupTrendsLegendData,
    resetLoadGroupTrendsLegendData,
    setLoadGroupTrendsLegendChannel,
    setLoadGroupTrendsUnitAndDuration,
} = loadGroupTrendsWidgetSlice.actions;
export default loadGroupTrendsWidgetSlice;
